"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["[_nghost-%COMP%]{height:100%;width:100%;padding:0}ngui-map[_ngcontent-%COMP%]{height:268px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;overflow:hidden}.no-results[_ngcontent-%COMP%]{margin-top:40px;width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}"];
exports.styles = styles;
